/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/feature/internal-error/internal-error.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '@angular/core/src/linker/view_type';
import * as import6 from '@angular/core/src/change_detection/constants';
import * as import7 from '@angular/core/src/linker/component_factory';
import * as import8 from '../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import9 from '@angular/router/src/router';
import * as import10 from '../../../../../public/upgrade/core/session.service';
import * as import11 from '../../../../../public/upgrade/core/window-ref';
import * as import12 from '../../../../../public/upgrade/shared/eva-button/eva-button.component';
import * as import13 from '../../shared/eva-button/eva-button.component.ngfactory';
import * as import14 from '@ngx-translate/core/src/translate.pipe';
import * as import15 from '@angular/core/src/change_detection/change_detection_util';
import * as import16 from '@ngx-translate/core/src/translate.service';
export class Wrapper_InternalErrorComponent {
  /*private*/ _eventHandler:Function;
  context:import0.InternalErrorComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any) {
    this._changed = false;
    this.context = new import0.InternalErrorComponent(p0,p1,p2,p3);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_InternalErrorComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_InternalErrorComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.InternalErrorComponent>;
  _InternalErrorComponent_0_3:Wrapper_InternalErrorComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_InternalErrorComponent_Host0,renderType_InternalErrorComponent_Host,import5.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'internal-error',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_InternalErrorComponent0(this.viewUtils,this,0,this._el_0);
    this._InternalErrorComponent_0_3 = new Wrapper_InternalErrorComponent(this.injectorGet(import8.LoadingWheelService,this.parentIndex),this.injectorGet(import9.Router,this.parentIndex),this.injectorGet(import10.SessionService,this.parentIndex),this.injectorGet(import11.WindowRef,this.parentIndex));
    this.compView_0.create(this._InternalErrorComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import7.ComponentRef_<any>(0,this,this._el_0,this._InternalErrorComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.InternalErrorComponent) && (0 === requestNodeIndex))) { return this._InternalErrorComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._InternalErrorComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const InternalErrorComponentNgFactory:import7.ComponentFactory<import0.InternalErrorComponent> = new import7.ComponentFactory<import0.InternalErrorComponent>('internal-error',View_InternalErrorComponent_Host0,import0.InternalErrorComponent);
const styles_InternalErrorComponent:any[] = ([] as any[]);
var renderType_InternalErrorComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_InternalErrorComponent,{});
export class View_InternalErrorComponent0 extends import1.AppView<import0.InternalErrorComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  _el_29:any;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _el_33:any;
  _text_34:any;
  _el_35:any;
  _text_36:any;
  _text_37:any;
  _text_38:any;
  _text_39:any;
  _text_40:any;
  _el_41:any;
  _text_42:any;
  _el_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _el_47:any;
  compView_47:import1.AppView<import12.EvaButtonComponent>;
  _EvaButtonComponent_47_3:import13.Wrapper_EvaButtonComponent;
  _text_48:any;
  _text_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _text_53:any;
  _text_54:any;
  _text_55:any;
  _text_56:any;
  /*private*/ _expr_59:any;
  _pipe_translate_0:import14.TranslatePipe;
  /*private*/ _expr_61:any;
  _pipe_translate_1:import14.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_InternalErrorComponent0,renderType_InternalErrorComponent,import5.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
    this._expr_59 = import15.UNINITIALIZED;
    this._expr_61 = import15.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-container'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-grid'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray4(4,'class','-md-12','style','text-align: center;'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                            ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'div',new import3.InlineArray2(2,'class','-md-12'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                                ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_14,'img',new import3.InlineArray8(6,'alt','','class','info-img','src','assets/500.png'),(null as any));
    this._text_17 = this.renderer.createText(this._el_14,'\n                            ',(null as any));
    this._text_18 = this.renderer.createText(this._el_12,'\n                        ',(null as any));
    this._text_19 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','eva-3-row '),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n                            ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_20,'div',new import3.InlineArray2(2,'class','-md-12'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n                                ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_22,'h3',new import3.InlineArray2(2,'class','-h3'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'',(null as any));
    this._text_26 = this.renderer.createText(this._el_22,'\n                            ',(null as any));
    this._text_27 = this.renderer.createText(this._el_20,'\n                        ',(null as any));
    this._text_28 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','eva-3-row '),(null as any));
    this._text_30 = this.renderer.createText(this._el_29,'\n                            ',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_29,'div',new import3.InlineArray4(4,'class','-md-12','style','text-align: -webkit-center;'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'\n                                ',(null as any));
    this._el_33 = import3.createRenderElement(this.renderer,this._el_31,'div',new import3.InlineArray2(2,'style','width: 420px;height: 66px;'),(null as any));
    this._text_34 = this.renderer.createText(this._el_33,'\n                                    ',(null as any));
    this._el_35 = import3.createRenderElement(this.renderer,this._el_33,'span',new import3.InlineArray2(2,'class','-p'),(null as any));
    this._text_36 = this.renderer.createText(this._el_35,'',(null as any));
    this._text_37 = this.renderer.createText(this._el_33,'\n                                ',(null as any));
    this._text_38 = this.renderer.createText(this._el_31,'\n                            ',(null as any));
    this._text_39 = this.renderer.createText(this._el_29,'\n                        ',(null as any));
    this._text_40 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_41 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','eva-3-row '),(null as any));
    this._text_42 = this.renderer.createText(this._el_41,'\n                            ',(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_41,'div',new import3.InlineArray4(4,'class','-md-12','style','text-align: -webkit-center;'),(null as any));
    this._text_44 = this.renderer.createText(this._el_43,'\n                                ',(null as any));
    this._el_45 = import3.createRenderElement(this.renderer,this._el_43,'div',new import3.InlineArray2(2,'style','width: 420px;height: 66px;'),(null as any));
    this._text_46 = this.renderer.createText(this._el_45,'\n                                    ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_45,'eva-button',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_47 = new import13.View_EvaButtonComponent0(this.viewUtils,this,47,this._el_47);
    this._EvaButtonComponent_47_3 = new import13.Wrapper_EvaButtonComponent();
    this.compView_47.create(this._EvaButtonComponent_47_3.context);
    this._text_48 = this.renderer.createText(this._el_45,'\n                                ',(null as any));
    this._text_49 = this.renderer.createText(this._el_43,'\n                            ',(null as any));
    this._text_50 = this.renderer.createText(this._el_41,'\n                        ',(null as any));
    this._text_51 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_52 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_53 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_54 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_55 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_56 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_translate_0 = new import14.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import14.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_47,new import3.InlineArray2(2,'action',(null as any)),this.eventHandler(this.handleEvent_47));
    this._EvaButtonComponent_47_3.subscribe(this,this.eventHandler(this.handleEvent_47),true);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._text_28,
      this._el_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._el_33,
      this._text_34,
      this._el_35,
      this._text_36,
      this._text_37,
      this._text_38,
      this._text_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._el_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._text_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._text_53,
      this._text_54,
      this._text_55,
      this._text_56
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import12.EvaButtonComponent) && (47 === requestNodeIndex))) { return this._EvaButtonComponent_47_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import15.ValueUnwrapper();
    const currVal_47_0_0:any = this.context.getButtonModel();
    this._EvaButtonComponent_47_3.check_button(currVal_47_0_0,throwOnChange,false);
    this._EvaButtonComponent_47_3.ngDoCheck(this,this._el_47,throwOnChange);
    valUnwrapper.reset();
    const currVal_59:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('internalError.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_59,currVal_59))) {
      this.renderer.setText(this._text_25,currVal_59);
      this._expr_59 = currVal_59;
    }
    valUnwrapper.reset();
    const currVal_61:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('internalError.SUBTITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_61,currVal_61))) {
      this.renderer.setText(this._text_36,currVal_61);
      this._expr_61 = currVal_61;
    }
    this.compView_47.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_47.destroy();
    this._EvaButtonComponent_47_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  handleEvent_47(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'action')) {
      const pd_sub_0:any = ((<any>this.context.handleButtonClick()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/internal-error/internal-error.component.ngfactory.ts